<template>
  <div class="gtj-board--main">
    <template v-if="hasTel">
      <p>
        <span class="label">管理员手机号码:</span>
        <span class="value">
        {{tel}}
      </span>
      </p>
      <p>
        <span class="label">管理员账号名:</span>
        <span class="value name">
        {{name}}
      </span>
      </p>
    </template>
    <template v-else>
      <p>
        <span class="label">管理员账号名:</span>
        <span class="value name">
        {{name}}
      </span>
      </p>
      <p>
        <span class="label">管理员初始密码:</span>
        <span class="value">
        {{password}}
      </span>
      </p>
    </template>
    <p class="mrg__72">
      <a href="javascript: void(0);" @click="downloadInstruction('open')">开通员工账号操作说明书</a>
      <a v-if="!hasTel" href="javascript: void(0);" @click="downloadInstruction('bind')">管理员账号绑定说明书</a>
    </p>
    <a class="button__back" href="javascript: void(0);" @click="back">
      返回首页
    </a>
  </div>
</template>
<style lang="less" type="text/less" scoped>
  .gtj-board--main{
    width: 960px;
    height: 100%;
    box-sizing: border-box;
    border: 1px solid #d8d8d8;
    margin: 0 auto;
    margin-top: 24px;
    padding: 60px  0 60px 100px;
    position: relative;
    p{
      line-height: 44px;
      margin-bottom: 18px;
      color: #555555;
      &.mrg__72{
        margin-top: 72px;
      }
      .value{
        margin-left: 60px;
        &.name{
          margin-left: 76px;
        }
      }
      a{
        display: inline-block;
        text-decoration: underline;
        color: #006FF0;
        &:first-child{
          margin-right: 46px;
        }
      }
    }
    .button__back{
      position: absolute;
      left: 100px;
      bottom: 32px;
      padding: 12px 24px;
      border: 1px solid #d8d8d8;
      border-radius: 4px;
      color: #000;
      font-size: 14px;
    }
  }
</style>
<script>
import boardService from '@/assets/service/board'
import { getCookie } from '@/assets/utils/CommonUtil'
import {mapState, mapMutations} from 'vuex'
export default {
  data () {
    return {
      name: '',
      tel: '',
      password: '88888888',
      hasTel: true
    }
  },
  computed: {
    ...mapState({
      userInfoReady: state => state.user.userInfoReady
    })
  },
  mounted () {
    this.getAdminInfo()
  },
  methods: {
    ...mapMutations({
      triggerInitPage: 'config/TRIGGER_INIT_PAGE_FUN'
    }),
    // 1. 获取管理员相关信息
    getAdminInfo () {
      console.log('拉出来溜溜。。。。。。')
      setTimeout(() => {
        // console.log(getCookie('ZJYTOKEN'))
        // console.log(this.userInfoReady)
        if (getCookie('ZJYTOKEN') && !this.userInfoReady) {
          this.triggerInitPage()
        }
        const gldDogNum = getCookie('DOGNUM') || '' // 锁号
        if (!gldDogNum) {
          this.$confirm({
            message: '请确定您是否已使用云锁账号，云锁账号即为企业员工账号，您可直接在软件上登录使用。无需再次获取。',
            width: 400,
            noCancelBtn: true,
            submit: () => {
              // this.back()
            }
          })
          return
        }
        boardService.getAdminInfo({dog_num: gldDogNum}).then(data => {
          // console.log(data)
          if (+data.code === 200) {
            if (data.data) {
              if (data.data.passwordMobile) {
                this.tel = data.data.passwordMobile
              } else {
                this.hasTel = false
              }
              this.name = data.data.username
            } else {
              // this.back()
            }
          } else {
            switch (+data.code) {
              case 210009:
                this.$confirm({
                  message: '当前登录账号获取企业账号频繁，您可尝试在软件登录其他账号再次获取。',
                  width: 420,
                  noCancelBtn: true,
                  submit: () => {
                    // this.back()
                  }
                })
                break
              default:
            }
          }
        })
      }, 500)
    },
    // 2. 下载相关说明文档
    downloadInstruction (type) {
      let fileUrl = ''
      switch (type) {
        case 'open':
          fileUrl = boardService.downloadOpenAccount()
          break
        case 'bind':
          fileUrl = boardService.downloadBindAccount()
          break
        default:
      }
      const token = getCookie('ZJYTOKEN')
      if (fileUrl && token) {
        fileUrl += '?token=' + token
        window.common.downloadFile(fileUrl)
      }
    },
    back () {
      this.$router.push({
        path: '/home'
      })
    }
  }
}
</script>
